import { useState, useEffect, useRef } from "react";
import toastError from "../../errors/toastError";
import { format, sub } from 'date-fns'
import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  kanbanTags,
  noKanban,
  noTag,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  whatsappIds,
  statusFilter,
  forceSearch,
  userFilter,
  sortTickets,
  searchOnMessages,
  filterAcrossStatuses
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);
  const [unreadTicketCount, setUnreadTicketCount] = useState(0);
  const requestIdRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        if (userFilter === undefined || userFilter === null) {
          try {            
            const { data } = await api.get("/tickets", {
              params: {
                searchParam,
                pageNumber,
                tags,
                kanbanTags,
                noKanban,
                noTag,
                users,
                status,
                date,
                updatedAt,
                showAll,
                queueIds,
                withUnreadMessages,
                whatsapps: whatsappIds,
                statusFilter,
                sortTickets,
                searchOnMessages,
                filterAcrossStatuses
              },
            });
            
            let tickets = [];
            
            tickets = data.tickets;
          
            if (requestId === requestIdRef.current) {
              setTickets(tickets);
              setHasMore(data.hasMore);
              setCount(data.count)
              setUnreadTicketCount(data.unreadTicketCount || 0)
              setLoading(false);
            }
          } catch (err) {
            if (requestId === requestIdRef.current) {
              setLoading(false);
              toastError(err);
            }
          }
        } else {
          try {
            // console.log("ENTROU AQUI DASH")
            // console.log(status,
            //   showAll,
            //   queueIds,
            //   format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
            //   format(new Date(), 'yyyy-MM-dd'),
            //   userFilter)

            const {data} = await api.get("/dashboard/moments", {
              params: {
                status,
                showAll,
                queueIds,
                dateStart: format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
                dateEnd: format(new Date(), 'yyyy-MM-dd'),
                userId: userFilter
              }
            })

            // console.log(data)
            let tickets = [];
            tickets = data.filter(item => item.userId == userFilter);            

            if (requestId === requestIdRef.current) {
              setTickets(tickets);
              setHasMore(null);
              setLoading(false);
            }
          } catch (err) {
            if (requestId === requestIdRef.current) {
              setLoading(false);
              toastError(err);
            }
          }
        }
      };
    fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    kanbanTags,
    noKanban,
    noTag,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    statusFilter,
    forceSearch,
    userFilter,
    sortTickets,
    searchOnMessages,
    filterAcrossStatuses
  ]);

  return { tickets, loading, hasMore, count, unreadTicketCount };
};

export default useTickets;
